import React from 'react';

import Stats from '../../Containers/ProfileStats/Stats';
import ProfileStats from '../../Containers/ProfileStats/ProfileStats';
import { LeftContainer, LeftContent, RightContainer, ColumnProfileContainer, RowProfileContainer } from './style';
import { Text } from '../../Layouts';

import screenWidthProvider from '../../Containers/HOCS/ScreenWidthProvider';
import { screenTypes } from '../../../Constants/screenTypes';

const ProfilePageWrapper = props =>
    props.screenWidth !== screenTypes.DESKTOP ? (
        <ColumnProfileContainer>
            <ProfileStats type={props.type} />
            {props.children}
        </ColumnProfileContainer>
    ) : (
        <RowProfileContainer>
            <LeftContainer background={props.cover || props.originalImage}>
                <LeftContent>
                    <Text center fontDeebby fontSize={80} marginBottom="30px">
                        {props.fullName}
                    </Text>
                    <Stats type={props.type} />
                </LeftContent>
            </LeftContainer>
            <RightContainer>{props.children}</RightContainer>
        </RowProfileContainer>
    );

export default screenWidthProvider(ProfilePageWrapper);



// WEBPACK FOOTER //
// ./src/UI/Components/ProfilePageWrapper/index.js